export const Colors: Record<string, number> = {
  grey: 0xb2b2b2,
}

export interface Controller {
  dispose?(): void
  resize?(): void
  show?(animate?: boolean): Promise<void>
  hide?(): Promise<void>
  update?(time: number): void
  load?(): Promise<void>
  scroll?(): void
}
